
// import React, { useContext } from "react";
// import { ShopContext } from "../../Context/ShopContext";
// import remove_icon from "../Assets/Frontend_Assets/cart_cross_icon.png";
// import "../CartItems/CartItems.css";
// import { useNavigate } from "react-router-dom";

// const CartItems = () => {
//   const navigate = useNavigate();
//   const {
//     cartItems,
//     all_product,
//     addToCart,
//     removeFromCart,
//     getTotalCartAmount,
//   } = useContext(ShopContext);

//   const subtotal = getTotalCartAmount();
//   const shippingFee = cartItems.length > 0 ? 150 : 0;
//   const grandTotal = subtotal + shippingFee;

//   return (
//     <div className="cartitems">
//       <h2 className="cart-title">Your Shopping Cart</h2>

//       {/* Header */}
//       <div className="cartitems-format-main cart-header">
//         <p>Image</p>
//         <p>Title</p>
//         <p>Size</p>
//         <p>Price</p>
//         <p>Qty</p>
//         <p>Total</p>
//         <p>Remove</p>
//       </div>

//       <hr />

//       {/* Cart Items */}
//       {cartItems.length === 0 && (
//         <p className="empty-cart">🛒 Your cart is empty</p>
//       )}

//       {cartItems.map((item, index) => {
//         const product = all_product.find(
//           (p) => p.product_id === item.product_id
//         );
//         if (!product) return null;

//         const price = Number(product.new_price || 0);
//         const sizeStock =
//           product.type === "stitched"
//             ? Number(product.sizes?.[item.size] || 0)
//             : Number(product.total_qty || 0);

//         const isOutOfStock = sizeStock <= 0;

//         return (
//           <div className="cartitems-format cartitem-row" key={index}>
//             <img
//               src={product.image}
//               className="carticon-product-icon"
//               alt={product.product_name}
//             />

//             <p>{product.product_name}</p>
//             <p>{item.size || "-"}</p>
//             <p>Rs.{price}</p>

//             <div className="qty-controls">
//               <button
//                 className="qty-btn"
//                 disabled={item.qty <= 1}
//                 onClick={() =>
//                   removeFromCart(item.product_id, item.size, 1)
//                 }
//               >
//                 -
//               </button>

//               <span className="qty-number">{item.qty}</span>

//               <button
//                 className="qty-btn"
//                 disabled={isOutOfStock}
//                 onClick={() =>
//                   addToCart(item.product_id, item.size, 1)
//                 }
//               >
//                 +
//               </button>
//             </div>

//             <p>Rs.{(price * item.qty).toFixed(2)}</p>

//             <img
//               className="cartitems-remove-icon"
//               src={remove_icon}
//               onClick={() =>
//                 removeFromCart(item.product_id, item.size)
//               }
//               alt="Remove"
//             />
//           </div>
//         );
//       })}

//       {/* Cart Summary */}
//       {cartItems.length > 0 && (
//         <div className="cartitems-down">
//           <div className="cartitems-total">
//             <h3>Cart Summary</h3>

//             <div className="cartitems-total-item">
//               <p>Subtotal</p>
//               <p>Rs.{subtotal}</p>
//             </div>

//             <div className="cartitems-total-item">
//               <p>Shipping</p>
//               <p>Rs.{shippingFee}</p>
//             </div>

//             <hr />

//             <div className="cartitems-total-item total-amount">
//               <p>Total</p>
//               <h2>Rs.{grandTotal}</h2>
//             </div>

//             <button onClick={() => navigate("/checkout/address")}>
//               PROCEED TO CHECKOUT
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CartItems;
// import React, { useContext } from "react";
// import { ShopContext } from "../../Context/ShopContext";
// import remove_icon from "../Assets/Frontend_Assets/cart_cross_icon.png";
// import "./CartItems.css";
// import { useNavigate } from "react-router-dom";

// const CartItems = () => {
//   const navigate = useNavigate();
//   const {
//     cartItems,
//     all_product,
//     addToCart,
//     removeFromCart,
//     getTotalCartAmount,
//   } = useContext(ShopContext);

//   const subtotal = getTotalCartAmount();
//   const shippingFee = cartItems.length > 0 ? 150 : 0;
//   const grandTotal = subtotal + shippingFee;

//   return (
//     <div className="cart-wrapper">
//       <h2 className="cart-title">🛒 Shopping Cart</h2>

//       {cartItems.length === 0 && (
//         <div className="empty-cart">
//           <p>Your cart is empty</p>
//           <button onClick={() => navigate("/")}>Continue Shopping</button>
//         </div>
//       )}

//       <div className="cart-layout">
//         {/* ITEMS */}
//         <div className="cart-items">
//           {cartItems.map((item, index) => {
//             const product = all_product.find(
//               (p) => p.product_id === item.product_id
//             );
//             if (!product) return null;

//             const price = Number(product.new_price || 0);
//             const stock =
//               product.type === "stitched"
//                 ? Number(product.sizes?.[item.size] || 0)
//                 : Number(product.total_qty || 0);

//             return (
//               <div className="cart-card" key={index}>
//                 <img src={product.image} alt={product.product_name} />

//                 <div className="cart-info">
//                   <h4>{product.product_name}</h4>
//                   <p className="size">Size: {item.size || "-"}</p>
//                   <p className="price">Rs. {price}</p>

//                   <div className="qty-controls">
//                     <button
//                       disabled={item.qty <= 1}
//                       onClick={() =>
//                         removeFromCart(item.product_id, item.size, 1)
//                       }
//                     >
//                       −
//                     </button>

//                     <span>{item.qty}</span>

//                     <button
//                       disabled={stock <= 0}
//                       onClick={() =>
//                         addToCart(item.product_id, item.size, 1)
//                       }
//                     >
//                       +
//                     </button>
//                   </div>

//                   <p className="item-total">
//                     Total: Rs. {(price * item.qty).toFixed(0)}
//                   </p>
//                 </div>

//                 <img
//                   src={remove_icon}
//                   className="remove-icon"
//                   onClick={() =>
//                     removeFromCart(item.product_id, item.size)
//                   }
//                   alt="remove"
//                 />
//               </div>
//             );
//           })}
//         </div>

//         {/* SUMMARY */}
//         {cartItems.length > 0 && (
//           <div className="cart-summary">
//             <h3>Order Summary</h3>

//             <div className="summary-row">
//               <span>Subtotal</span>
//               <span>Rs. {subtotal}</span>
//             </div>

//             <div className="summary-row">
//               <span>Shipping</span>
//               <span>Rs. {shippingFee}</span>
//             </div>

//             <hr />

//             <div className="summary-total">
//               <span>Total</span>
//               <span>Rs. {grandTotal}</span>
//             </div>

//             <button onClick={() => navigate("/checkout/address")}>
//               Proceed to Checkout
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CartItems;



import React, { useContext, useMemo } from "react";
import { ShopContext } from "../../Context/ShopContext";
import remove_icon from "../Assets/Frontend_Assets/cart_cross_icon.png";
import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
import "./CartItems.css";
import { useNavigate } from "react-router-dom";

const CartItems = () => {
  const navigate = useNavigate();

  const {
    cartItems,
    cartProducts,
    loading,
    addToCart,
    removeFromCart,
    getTotalCartAmount,
  } = useContext(ShopContext);

  // normalize cart items
  const normalizedCartItems = useMemo(() => {
    if (Array.isArray(cartItems)) return cartItems;
    if (cartItems && typeof cartItems === "object") return Object.values(cartItems);
    return [];
  }, [cartItems]);

  if (loading) {
    return (
      <div className="cart-wrapper">
        <p style={{ textAlign: "center" }}>Loading cart...</p>
      </div>
    );
  }

  const subtotal = getTotalCartAmount();
  const shippingFee = normalizedCartItems.length > 0 ? 150 : 0;
  const grandTotal = subtotal + shippingFee;

  return (
    <div className="cart-wrapper">
      <h2 className="cart-title">🛒 Shopping Cart</h2>

      {normalizedCartItems.length === 0 && (
        <div className="empty-cart">
          <p>Your cart is empty</p>
          <button onClick={() => navigate("/")}>Continue Shopping</button>
        </div>
      )}

      <div className="cart-layout">
        {/* ITEMS */}
        <div className="cart-items">
          {normalizedCartItems.map((item, index) => {
            const product = cartProducts.find(
              (p) => p.product_id === item.product_id
            );

            if (!product) {
              return (
                <div
                  className="cart-card"
                  key={`${item.product_id}-${item.size}-${index}`}
                >
                  <p>Product loading...</p>
                </div>
              );
            }

            const price = Number(product.new_price || 0);
            const stock =
              product.type === "stitched"
                ? Number(product.sizes?.[item.size] || 0)
                : Number(product.total_qty || 0);

            return (
              <div
                className="cart-card"
                key={`${item.product_id}-${item.size}-${index}`}
              >
                <img
                  src={product.image || placeholder}
                  alt={product.product_name}
                  onError={(e) => (e.target.src = placeholder)}
                />

                <div className="cart-info">
                  <h4>{product.product_name}</h4>
                  <p className="size">Size: {item.size || "-"}</p>
                  <p className="price">Rs. {price}</p>

                  <div className="qty-controls">
                    <button
                      disabled={item.qty <= 1}
                      onClick={() => removeFromCart(item.product_id, item.size, 1)}
                    >
                      −
                    </button>
                    <span>{item.qty}</span>
                    <button
                      disabled={stock <= 0}
                      onClick={() => addToCart(item.product_id, item.size, 1)}
                    >
                      +
                    </button>
                  </div>

                  <p className="item-total">
                    Total: Rs. {(price * item.qty).toFixed(0)}
                  </p>
                </div>

                <img
                  src={remove_icon}
                  className="remove-icon"
                  onClick={() => removeFromCart(item.product_id, item.size)}
                  alt="remove"
                />
              </div>
            );
          })}
        </div>

        {/* SUMMARY */}
        {normalizedCartItems.length > 0 && (
          <div className="cart-summary">
            <h3>Order Summary</h3>

            <div className="summary-row">
              <span>Subtotal</span>
              <span>Rs. {subtotal}</span>
            </div>

            <div className="summary-row">
              <span>Shipping</span>
              <span>Rs. {shippingFee}</span>
            </div>

            <hr />

            <div className="summary-total">
              <span>Total</span>
              <span>Rs. {grandTotal}</span>
            </div>

            <button onClick={() => navigate("/checkout/address")}>
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartItems;
